import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between w-full bg-darkgreyblue h-12" }
const _hoisted_2 = { class: "grow flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/icons/apple-touch-icon.png",
  style: {"padding":"4px"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "" }, null, -1)
const _hoisted_5 = { class: "grow flex flex-row-reverse" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SignOutButton = _resolveComponent("SignOutButton")!
  const _component_SignInButton = _resolveComponent("SignInButton")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu, index) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: index,
          to: menu.url,
          class: "inline-block leading-8 p-2 text-white hover:bg-purple"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(menu.title), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (_ctx.isAuthenticated)
        ? (_openBlock(), _createBlock(_component_SignOutButton, { key: 0 }))
        : (_openBlock(), _createBlock(_component_SignInButton, { key: 1 }))
    ])
  ]))
}